import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/images/list-bg-17.png'


const _hoisted_1 = { class: "w1200 clearfix eva-all-box" }
const _hoisted_2 = { class: "eva-all" }
const _hoisted_3 = { class: "eva-all-top clearfix" }
const _hoisted_4 = { class: "eva-all-top-box clearfix" }
const _hoisted_5 = {
  class: "t2-search-form2",
  action: "search"
}
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "cont" }
const _hoisted_8 = { class: "left_cont" }
const _hoisted_9 = { class: "text_list" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "right_cont" }
const _hoisted_12 = { class: "clearfix" }

import {ref, onBeforeMount, reactive} from "vue";
import {useRouter} from "vue-router";
import {getNewsContentList} from "@/config/request";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()
let keyWord = ref('')
const contentList = ref([])
onBeforeMount(()=>{
    init();
})
const init = async () => {
    let params = {
        title: '',
        pageNo: 1,
        pageSize: 5
    }
    const res = await getNewsContentList(params) as any
    contentList.value = res.result.records;
}

const search = () => {
    let params = {
        title: "*"+keyWord.value+"*",
    }
    router.push({
        path: '/news-list',
        query: params
    })
}

const goDetail = (num:any) => {
    if(num == 1) {
        window.open("/staticFile/disclosureUponRequest.doc");
    }else if(num == 2) {
        router.push('/other-page/consult')
    }else if(num == 3) {
        router.push('/other-page/complainList')
    }
}
const showDetail = (item:any) => {
    router.push({
        path: '/news-detail',
        query:{
            id: item.id
        }
    })
}

return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Top, { fixedNobanner: true }),
    _cache[9] || (_cache[9] = _createElementVNode("div", {
      class: "no_banner",
      id: "no_banner"
    }, null, -1)),
    _createElementVNode("div", null, [
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "clearfix eva-banner" }, [
        _createElementVNode("div", { class: "w1200 banner-box" }, [
          _createElementVNode("div", { class: "banner-left" }, [
            _createElementVNode("div", null, "政务公开专区")
          ])
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { style: {"font-size":"20px","margin-bottom":"10px"} }, "政府信息查询", -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(keyWord) ? (keyWord).value = $event : keyWord = $event)),
                    onKeyup: _withKeys(search, ["enter"]),
                    placeholder: "请输入您要查询的信息或关键字"
                  }, null, 544), [
                    [_vModelText, _unref(keyWord)]
                  ])
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "t2-btn-search2",
                  onClick: search
                }, "搜索")
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: "moreList",
            onClick: search
          }, "查看更多>>"),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("ul", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contentList.value, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.id,
                    onClick: ($event: any) => (showDetail(item))
                  }, [
                    _createElementVNode("a", null, _toDisplayString(item.title), 1),
                    _createElementVNode("span", null, _toDisplayString(item.releaseDate), 1)
                  ], 8, _hoisted_10))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("ul", _hoisted_12, [
                _createElementVNode("li", {
                  class: "cont_li",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (goDetail(1)))
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("span", null, [
                    _createElementVNode("img", { src: _imports_0 })
                  ], -1),
                  _createElementVNode("a", { href: "javascript:;" }, "信息公开申请", -1)
                ]))]),
                _createElementVNode("li", {
                  class: "cont_li",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (goDetail(2)))
                }, [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("span", null, [
                    _createElementVNode("img", { src: _imports_0 })
                  ], -1),
                  _createElementVNode("a", { href: "javascript:;" }, "办事咨询", -1)
                ]))]),
                _createElementVNode("li", {
                  class: "cont_li",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (goDetail(3)))
                }, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("span", null, [
                    _createElementVNode("img", { src: _imports_0 })
                  ], -1),
                  _createElementVNode("a", { href: "javascript:;" }, "咨询回复", -1)
                ]))])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Bottom)
  ]))
}
}

})